/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IssueStatus {
  Unknown = 0,
  Registered = 1,
  New = 2,
  InProgress = 3,
  ClaimProcessed = 4,
  Processed = 5,
  Closed = 6,
  Reopened = 7,
}
